import { useContext } from "react";
import { ICphContextType } from "../types/interfaces/ICphContextType";
import { CphContext } from "../contexts/CphContext";

//This custom hook is responsible for consuming the cph context.
export function useCphContext(): ICphContextType {
    const context = useContext(CphContext);

    if (!context) {
        throw new Error('The useCphContext must be used within a CphProvider.');
    }

    return context;
}